import { WebRoutes } from "consts/enpoints/web";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { Step } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";
import { useUploadDocuments } from "./useUploadDocuments";

const UploadDocuments = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const uploadDocuments = useUploadDocuments();

    return (
        <Step
            title='Upload Documents'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.UploadDocuments.Form
                {...uploadDocuments}
            />
        </Step>
    );
};

export default UploadDocuments;
// export default withApplication(UploadDocuments);
